module.exports = __webpack_public_path__ + "static/media/3DPPA1.a608a1e2.jpg";